import * as React from 'react';

function Star(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 4l2.124 6.374H21l-5.563 3.94 2.125 6.374L12 16.748l-5.562 3.94 2.125-6.375L3 10.375h6.876L12 4z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Star;
